import { CustomerEntity } from "Models/Entities";

// Display the customers state liquor license details
export function CustomerStateLiquorLicenseDetails(props: {
	customer: CustomerEntity
}) {
	const { customer } = props;

	const details: { label: string; value: string }[] = [
		{ label: "Status", value: customer.getLiquorStatus() },
		{ label: "Channel", value: customer.getLiquorChannel() },
		{ label: "Sub Channel", value: customer.getLiquorSubChannel() },
		{ label: "Channel Category", value: customer.getLiquorChannelCategory() },
		{ label: "Active Since", value: customer.getLiquorActiveSince() },
	];

	return (
		<>
			{details.map(({ label, value }) => (
				<div key={label}>
					<b>{label}:</b> {value}
				</div>
			))}
		</>
	)
}
